const About = () => (
    <div className="space-y-4">
        <h2 className="text-2xl font-bold">Our Story</h2>
        <div className="max-w-5xl">
            Why We Created AskBobo
            <br/>
            Language is a vital part of human culture—and for the Bukharian Jewish community, it is a lifeline to our
            identity. Losing our language means losing connection to our heritage, our history, and our elders. That’s
            why we launched AskBobo—the first online Bukharian language dictionary.
            <br/><br/>
            Our goal is simple: Just like the early 20th-century movement to revive modern Hebrew, or today’s efforts to
            preserve Yiddish and Ladino, we want to ensure that young Bukharian Jews have access to the Bukhory
            language—so they can stay connected to who we are and where we come from. This project aims not only to
            preserve our heritage but to strengthen intergenerational relationships between youth and elders within the
            Bukharian Jewish community.
            <br/><br/>
            For many years, Bukharian Jews lived throughout Central Asia—in present-day Uzbekistan, Tajikistan,
            Kazakhstan, Turkmenistan, and Kyrgyzstan—and developed our own language: Bukhory, a Judeo-Persian dialect.
            But in 1940, the Soviet regime officially shut down all Bukhory-speaking schools and banned the printing of
            Bukhory books and media. Since then, the language has survived mainly through the dedication of our elders,
            who have continued using it as their primary form of communication.
            <br/><br/>
            Why AskBobo?
            <br/><br/>
            We noticed that there is no digital platform dedicated to learning the Bukharian language—and that’s where
            AskBobo comes in.
            <br/>
            AskBobo, which means “Ask Grandfather,” is the result of a collaboration between Bukharian Jewish educators,
            scholars, historians, philosophers and AI from the United States and Israel.
            <br/><br/>
            It is more than a dictionary—it’s a growing resource and a movement
        </div>

    </div>
);
export default About;
